// Native
import { Box, Flex, HStack, Text } from "@chakra-ui/react"

// Custom
import { UI } from "components"

export default function(props){

    const color = 'teal'
    const icon = 'alert'
    const title = 'Nota de Atualização!'
    const description = 'Alguns cosméticos tiveram os valores atualizados de volta ao preço padrão definido, os mesmos vinham sendo vendidos abaixo do valor mínimo para fim de movimentar o grande estoque fisico disponível, com o investimento da promoção a ser lançada os mesmos estão retornando ao valor piso.'

    return(
    <UI.Box colorPalette={color} {...props}>
        <Flex h="100%" alignItems="center" justifyContent="center">
            <HStack gap={4}>
                <UI.Avatar backgroundColor={color} icon={<UI.Icon name={icon} />} />
                <Box>
                    <Text children={title} fontSize="lg" fontWeight="bold" color={color + '.fg'} />
                    <Text children={description} fontSize="xs" color={color + '.fg'} />
                </Box>
            </HStack>
        </Flex>
    </UI.Box>
    )
}
